var Topic = require('./topic')

var BasUtil = require('@basalte/bas-util')
var P = require('./parser_constants')
var Device = require('./device')

/**
 * @typedef {Object} TBasStreamingLogin
 * @property {string} defaultName
 * @property {string} [nameKey]
 * @property {Array<TBasStreamingLoginGroup>} [children]
 */

/**
 *
 * @typedef {Object} TBasStreamingLoginGroup
 * @property {string} defaultName
 * @property {string} [nameKey]
 // eslint-disable-next-line max-len
 * @property {Array<TBasStreamingLoginGroup|TBasStreamingLoginService>} [children]
 */

/**
 * @typedef {Object} TBasStreamingLoginService
 * @property {string} id
 * @property {string} defaultName
 * @property {boolean} linked
 * @property {string} [loginType]
 * @property {string} [url]
 * @property {string} [username]
 * @property {string} [translationKey]
 */

/**
 * Class representing stream login API
 *
 * @constructor
 * @extends Topic
 * @param {BasCore} basCore
 */
function LoginTopic (basCore) {

  Topic.call(this, basCore)

  this.topic = P.LOGIN
}

LoginTopic.prototype = Object.create(Topic.prototype)
LoginTopic.prototype.constructor = LoginTopic

LoginTopic.EVT_SERVICE_UPDATED = 'evtLoginTopicServiceUpdated'

/**
 * @typedef {Object} TLoginTopicService
 * @property {boolean} linked
 * @property {string} username
 */

/**
 * Parse a login topic message
 *
 * @param {Object} msg
 */
LoginTopic.prototype.parse = function (msg) {

  var data

  if (msg && msg[P.DATA]) {

    data = msg[P.DATA]

    if (BasUtil.isBool(data[P.LINKED])) {

      this.emit(LoginTopic.EVT_SERVICE_UPDATED, {
        linked: data[P.LINKED],
        username: data[P.USERNAME] || ''
      })
    }
  }
}

/**
 *
 * @param {string} id
 */
LoginTopic.prototype.unlinkStreamingService = function (id) {

  var data

  data = {}
  data[P.ACTION] = P.LOGOUT
  data[P.ID] = id

  return this._request(data)
}

/**
 *
 * List streaming services
 *
 * @returns {Promise<Array<TBasStreamingLogin>>}
 */
LoginTopic.prototype.listStreamingServices = function () {
  var data

  data = {}
  data[P.ACTION] = P.GET_SERVICES

  return this._request(data)
    .then(function (response) {
      if (
        response &&
        response[P.DATA] &&
        Array.isArray(response[P.DATA])
      ) {
        return response[P.DATA]
      }

      return []
    })
}

/**
 *
 * @param {Object} data
 * @returns {Promise}
 */
LoginTopic.prototype._request = function (data) {

  var msg

  msg = {}
  msg[P.TOPIC] = P.LOGIN
  msg[P.DATA] = data

  return this._basCore.requestV2(msg)
    .then(Device.handleResponse)
}

module.exports = LoginTopic
